import { Item, Title } from "../../Component/MuiEx"
import { Button,Box, Grid, Stack, Typography, Alert, Paper, Divider, } from '@mui/material';
import { useEffect, useState } from "react";
import { apiResult, getUserSession, } from "../../Utils/Common";
import apis from "../../api";
import AddCompanyDialog from "./fragement/AddCompanyDialog";
import JoinCompanyDialog from "./fragement/JoinCompanyDialog";
const MerchantHome = (props) => {
    const [profile, setUserProfile] = useState({})
    const [error, setError] = useState()
    const [showDialog, setShowDialog] = useState(false)
    const [showDialog1, setShowDialog1] = useState(false)
    getUserSession(apis)
    useEffect(() => {
        apis.userMerchant().then(ret => {
            apiResult(ret, setUserProfile, setError)
        })
    }, [])
    const handleDialogClose = () => {
        setShowDialog(false)
    }
    const handleDialogSubmit = (result) => {
        setShowDialog(false)
        //sessionSet('merchant_auth',result)
        window.location.href = '/service/dashboard'
    }
    const handleDialog1Close = () => {
        setShowDialog1(false)
    }
    const handleDialog1Submit = (result) => {
        setShowDialog1(false)
        //sessionSet('merchant_auth',result)
        window.location.href = '/service/dashboard'
    }
    const handleAdd = () => {
        setShowDialog(true)
    }
    const handleJoin = () => {
        setShowDialog1(true)
    }
   
    return (
        <>
            {error && <Alert severity="error">{error}</Alert>}

            {profile && profile.merchant ?<Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
                <Title>School information</Title>
                <Typography sx={{ mt: 2 }} variant="body1" component="div" gutterBottom>
                    School name: <b>{profile && profile.merchant.name}</b>
                </Typography>
                <Typography sx={{ mt: 2 }} variant="body1" component="div" gutterBottom>
                    Contact Information
                </Typography>
                <Grid container>
                    <Grid item xs={12} sm={2}>
                        <Typography variant="body1" component="div" gutterBottom>Contact person</Typography>
                    </Grid>
                    <Grid item xs={12} sm={2}>
                        <Typography variant="body1" sx={{ fontWeight: "bold" }} component="div" gutterBottom>{profile.merchant.contact_person}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={2}>
                        <Typography variant="body1" component="div" gutterBottom>Email</Typography>
                    </Grid>
                    <Grid item xs={12} sm={2}>
                        <Typography variant="body1" sx={{ fontWeight: "bold" }} component="div" gutterBottom>{profile.merchant.contact_email}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={2}>
                        <Typography variant="body1" component="div" gutterBottom>Phone number</Typography>
                    </Grid>
                    <Grid item xs={12} sm={2}>
                        <Typography variant="body1" sx={{ fontWeight: "bold" }} component="div" gutterBottom>{profile.merchant.contact_phone}</Typography>
                    </Grid>
                </Grid>
                <Typography sx={{ mt: 2 }} variant="body1" component="div" gutterBottom>
                    School Address
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: "bold" }} component="div" gutterBottom>
                    {profile.merchant.address}, {profile.merchant.city}, {profile.merchant.province}, {profile.merchant.country} {profile.merchant.zipcode}
                </Typography>
                </Paper>

             :
                <Paper>
                    <Alert severity="info">You don't have any school information yet!</Alert>
                    <Stack spacing={2} mt={2} direction="row">
                        <Button variant="text" onClick={handleAdd}>Add</Button>
                        <Button variant="text" onClick={handleJoin}>Join</Button>
                    </Stack>
                </Paper>
            }
            {showDialog && <AddCompanyDialog open={showDialog} onClose={handleDialogClose} onSubmit={handleDialogSubmit} />}
            {showDialog1 && <JoinCompanyDialog open={showDialog1} onClose={handleDialog1Close} onSubmit={handleDialog1Submit} />}
        </>
    );
}

export default MerchantHome